// @ts-nocheck
import React, {useState} from 'react'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import {useNavigate} from 'react-router-dom'
import 'yup-phone'
import axios from 'axios'
import {BASE_URL} from '../../../api'

const profileDetailsSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  email: Yup.string().required('Email is required').email('not a valid email address'),
  type: Yup.string().required('Type is required'),
  country: Yup.string().required('Country is required'),
  access: Yup.object().required('Access is required'),
  phone: Yup.string()
    .matches(/^\+?[1-9]\d{1,14}$/, 'Please enter a valid phone number')
    .required('Phone number is required'),
  password: Yup.string().required('Password is required').min(6).max(20),
  confirmPassword: Yup.string().oneOf([Yup.ref('password'), null], 'Passwords must match'),
})

const NewSubAdmin: React.FC = () => {
  const [isLoading, setLoading] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [message, setMessage] = useState('')
  const [error, setError] = useState(false)

  const formik = useFormik<any>({
    initialValues: {
      name: '',
      email: '',
      type: '',
      country: '',
      access: {
        isUser: false,
        isSupport: false,
        isSettings: false,
        isTransactions: false,
        isReport: false,
        isClasses: false,
        isBookings: false,
      },
      phone: '',
      password: '',
      confirmPassword: '',
    },

    validationSchema: profileDetailsSchema,
    onSubmit: async (values) => {
      console.log(values, 'values')
      setMessage(' ')
      try {
        setLoading(true)

        const response = await axios.post(`${BASE_URL}/admin/sub-admin`, {
          name: values.name,
          email: values.email,
          type: values.type,
          country: values.country,
          access: {
            isUser: values.access.isUser,
            isSupport: values.access.isSupport,
            isSettings: values.access.isSettings,
            isTransactions: values.access.isTransactions,
            isReport: values.access.isReport,
            isClasses: values.access.isClasses,
            isBookings: values.access.isBookings,
          },
          phone: values.phone,
          password: values.password,
        })
        console.log('Response:', response.data)

        setMessage('Sub Admin Added Successfully')
      } catch (error) {
        console.log(error, 'error')
        setMessage(error.message)
        setError(true)
      } finally {
        setLoading(false)
        setShowModal(true)
        formik.resetForm()
      }
    },
  })

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div
          className='card-header border-0 cursor-pointer'
          role='button'
          data-bs-toggle='collapse'
          data-bs-target='#kt_account_profile_details'
          aria-expanded='true'
          aria-controls='kt_account_profile_details'
        >
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>Add Sub Admin</h3>
          </div>
        </div>

        <div id='kt_account_profile_details' className='collapse show'>
          <form onSubmit={formik.handleSubmit} noValidate className='form'>
            <div className='card-body border-top p-9'>
              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label required fw-bold fs-6'>Full Name</label>

                <div className='col-lg-8 fv-row'>
                  <input
                    type='text'
                    className='form-control form-control-lg form-control-solid'
                    placeholder='Name'
                    {...formik.getFieldProps('name')}
                  />
                  {formik.touched.name && formik.errors.name && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.name}</div>
                    </div>
                  )}
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                  <span className='required'>Email</span>
                </label>

                <div className='col-lg-8 fv-row'>
                  <input
                    type='email'
                    className='form-control form-control-lg form-control-solid'
                    placeholder='ray@lfs.com'
                    {...formik.getFieldProps('email')}
                  />
                  {formik.touched.email && formik.errors.email && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.email}</div>
                    </div>
                  )}
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                  <span className='required'>Role</span>
                </label>

                <div className='col-lg-8 fv-row'>
                  <input
                    type='text'
                    className='form-control form-control-lg form-control-solid'
                    placeholder='Role'
                    {...formik.getFieldProps('type')}
                  />
                  {formik.touched.type && formik.errors.type && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.type}</div>
                    </div>
                  )}
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                  <span className='required'>Country</span>
                </label>

                <div className='col-lg-8 fv-row'>
                  <input
                    type='text'
                    className='form-control form-control-lg form-control-solid'
                    placeholder='Country'
                    {...formik.getFieldProps('country')}
                  />
                  {formik.touched.country && formik.errors.country && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.country}</div>
                    </div>
                  )}
                </div>
              </div>

              <div className='row mb-6'>
                <div className='col-md-4'>
                  <label htmlFor='access' className='col-lg-4 col-form-label fw-bold fs-6'>
                    <span className='required'>Access</span>
                  </label>
                </div>
                <div className='col-md-8 fv-row'>
                  <div className='row'>
                    <div className='col-md-6'>
                      <div className='form-check my-2'>
                        <input
                          className='form-check-input'
                          type='checkbox'
                          id='user-management-access'
                          {...formik.getFieldProps('access.isUser')}
                        />
                        <label className='form-check-label' htmlFor='user-management-access'>
                          User Management Access
                        </label>
                      </div>
                      <div className='form-check my-2'>
                        <input
                          className='form-check-input'
                          type='checkbox'
                          id='support-access'
                          {...formik.getFieldProps('access.isSupport')}
                        />
                        <label className='form-check-label' htmlFor='support-access'>
                          Support Access
                        </label>
                      </div>
                      <div className='form-check my-2'>
                        <input
                          className='form-check-input'
                          type='checkbox'
                          id='settings-access'
                          {...formik.getFieldProps('access.isSettings')}
                        />
                        <label className='form-check-label' htmlFor='settings-access'>
                          Settings Access
                        </label>
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <div className='form-check my-2'>
                        <input
                          className='form-check-input'
                          type='checkbox'
                          id='report-access'
                          {...formik.getFieldProps('access.isReport')}
                        />
                        <label className='form-check-label' htmlFor='report-access'>
                          Report Access
                        </label>
                      </div>
                      <div className='form-check my-2'>
                        <input
                          className='form-check-input'
                          type='checkbox'
                          id='category-management-access'
                          {...formik.getFieldProps('access.isClasses')}
                        />
                        <label className='form-check-label' htmlFor='category-management-access'>
                          Classes Management Access
                        </label>
                      </div>
                      <div className='form-check my-2'>
                        <input
                          className='form-check-input'
                          type='checkbox'
                          id='content-access'
                          {...formik.getFieldProps('access.isBookings')}
                        />
                        <label className='form-check-label' htmlFor='content-access'>
                          Bookings Management Access
                        </label>
                      </div>
                      <div className='form-check my-2'>
                        <input
                          className='form-check-input'
                          type='checkbox'
                          id='ads-access'
                          {...formik.getFieldProps('access.isTransactions')}
                        />
                        <label className='form-check-label' htmlFor='ads-access'>
                          Transaction Management Access
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                  <span className='required'>Phone</span>
                </label>

                <div className='col-lg-8 fv-row'>
                  <input
                    type='text'
                    className='form-control form-control-lg form-control-solid'
                    placeholder='Phone Number'
                    {...formik.getFieldProps('phone')}
                  />
                  {formik.touched.phone && formik.errors.phone && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.phone}</div>
                    </div>
                  )}
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                  <span className='required'>Password</span>
                </label>

                <div className='col-lg-8 fv-row'>
                  <input
                    type='password'
                    className='form-control form-control-lg form-control-solid'
                    placeholder='Password'
                    {...formik.getFieldProps('password')}
                  />
                  {formik.touched.password && formik.errors.password && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.password}</div>
                    </div>
                  )}
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                  <span className='required'> Confirm Password</span>
                </label>

                <div className='col-lg-8 fv-row'>
                  <input
                    type='password'
                    className='form-control form-control-lg form-control-solid'
                    placeholder='Confirm Password'
                    {...formik.getFieldProps('confirmPassword')}
                  />
                  {formik.touched.confirmPassword && formik.errors.confirmPassword && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.confirmPassword}</div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className='card-footer d-flex justify-content-end py-6 px-9'>
              {/* <NavLink
             to='/apps/user-management/users'
             > */}
              <button type='submit' className='btn btn-primary'>
                {!isLoading && 'Add Sub Admin'}
                {isLoading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Please wait...{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
              {/* </NavLink> */}
            </div>
          </form>
        </div>
        {showModal && (
          <MessageModal
            error={error}
            showModal={showModal}
            setShowModal={setShowModal}
            message={message}
          />
        )}
      </div>
    </>
  )
}

const MessageModal = ({showModal, setShowModal, message, error}) => {
  const navigate = useNavigate()
  return (
    <>
      {' '}
      <>
        <div
          className='modal fade show d-block'
          id='kt_modal_add_user'
          role='dialog'
          tabIndex={-1}
          aria-modal='true'
        >
          <div className='modal-dialog modal-dialog-centered mw-550px'>
            <div className='modal-content'>
              <div className='modal-body scroll-y '>
                <div className='modal-header'>
                  <h5 className='modal-title fs-2'>{error ? 'Error' : 'Success'}</h5>
                </div>
                <div className='modal-body fs-3'>
                  <p>{message}</p>
                </div>
                <div className='modal-footer'>
                  <button
                    onClick={() => {
                      setShowModal(false)
                      // navigate("apps/user-management/users")
                      navigate(-1)
                      // navigate(-1);
                    }}
                    type='button'
                    className='btn btn-primary'
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='modal-backdrop fade show'></div>
      </>
    </>
  )
}

export default NewSubAdmin
